
import React from 'react';
import { Loader2 } from 'lucide-react';

const ArticleLoading = () => {
  return (
    <div className="flex items-center justify-center min-h-screen">
      <Loader2 className="h-8 w-8 animate-spin" />
    </div>
  );
};

export default ArticleLoading;
